// extracted by mini-css-extract-plugin
module.exports = {"wrap":"links-dropdown_wrap__XMR4D","dropdownMenu":"links-dropdown_dropdownMenu__9TtaA","netw":"links-dropdown_netw__pDMPA","active":"links-dropdown_active__JEFBI"};